export interface TrackSelection {
  id: string;
  label: string;
  url: string;
}

export const DEFAULT_TRACK_ID = 'twin-suns-autodrome';

export const TRACK_SELECTIONS: Record<string, TrackSelection> = {
  'twin-suns-autodrome': {
    id: 'twin-suns-autodrome',
    label: 'Twin Suns Autodrome',
    url: '/tracks/twin-suns-autodrome-arcade.csv',
  },
  'canyon-circuit': {
    id: 'canyon-circuit',
    label: 'Canyon Circuit',
    url: '/tracks/canyon-circuit.csv',
  },
};

export function resolveTrackSelection(params: URLSearchParams): TrackSelection {
  const requested = params.get('track')?.trim() ?? '';
  return TRACK_SELECTIONS[requested] ?? TRACK_SELECTIONS[DEFAULT_TRACK_ID];
}
